import { render, staticRenderFns } from "./PaymentInvoices.vue?vue&type=template&id=1537ac00"
import script from "./PaymentInvoices.vue?vue&type=script&lang=js"
export * from "./PaymentInvoices.vue?vue&type=script&lang=js"
import style0 from "./PaymentInvoices.vue?vue&type=style&index=0&id=1537ac00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports